import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // Import useLocation from react-router
import Breadcrumb from '../Components/Breadcrumb';

function Result() {
  const location = useLocation(); // Access the location object

  useEffect(() => {
    // Log the entire query string
    console.log('Location:', location);

    // To extract query parameters
    const urlParams = new URLSearchParams(location.search); // Use URLSearchParams to get query params
    const status = urlParams.get('status'); // Get the 'status' parameter from the URL

    // Log the value of 'status'
    console.log('Status parameter:', status); // Output: 123 (in your case)

    // Optional: Scroll to the top of the page
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <>
      <Breadcrumb title_1="Your Account" title_2="Orders" title_3="Track Return" />
    
    </>
  );
}

export default Result;
